import { RedirectUrl } from 'core/redirect'

export class EnterSearchObserver {

  constructor() {
      this.searchUrl = '/buscarProduto.do?paginaAtual=1&termoPesquisa='
  }

  next(termo) {
    if(termo)
      new RedirectUrl(`${this.searchUrl + encodeURI(termo)}`)
  }

  error(error) {}

  complete() {}

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/search/enterSearch.observer.js